"use client";
import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { useMatches as l, rem as a, Grid as i, Group as s, Box as I, Paragraph as o, Heading as y, Icon as d } from "@ingeniorforeningen/figurine-core";
import { S as h } from "../../../../ListItem.module-B89DN3XQ.js";
import '../../../../assets/ListItemWithoutImage.css';const f = "_root_1nx4i_2", L = "_content_1nx4i_48", N = "_heading_1nx4i_64", S = "_date_1nx4i_83", n = {
  root: f,
  content: L,
  heading: N,
  date: S
}, p = (g) => {
  const { date: m, description: u, header: x, size: e } = g, v = l({
    base: "short",
    sm: "long"
  }), _ = l({
    base: "h4",
    sm: e === "large" ? "h2" : "h3"
  });
  let c = a("6px");
  return e === "large" && (c = a("16px")), /* @__PURE__ */ r(i, { container: !0, spacing: 0, className: n.root, mod: { size: e }, children: [
    /* @__PURE__ */ t(i, { item: !0, children: /* @__PURE__ */ r(
      s,
      {
        direction: "column",
        spacing: c,
        pos: "relative",
        mod: { size: e },
        className: n.content,
        children: [
          /* @__PURE__ */ t(I, { className: h.withBottomShadow }),
          /* @__PURE__ */ t(s, { children: m && /* @__PURE__ */ t(
            o,
            {
              text: `${m?.toLocaleString("da-DK", {
                year: "numeric",
                month: v,
                day: "numeric"
              })}`,
              scale: 0.875,
              condensed: !0,
              transform: "uppercase",
              pos: "relative",
              variant: "primary",
              className: n.date
            }
          ) }),
          /* @__PURE__ */ t(
            y,
            {
              text: x,
              type: _,
              lineClamp: 3,
              pos: "relative",
              className: n.heading,
              mod: { size: e },
              variant: "dark"
            }
          ),
          e !== "small" && /* @__PURE__ */ t(
            o,
            {
              condensed: !0,
              lineClamp: e === "large" ? 5 : 3,
              pos: "relative",
              visibleFrom: e === "large" ? "base" : "sm",
              text: u
            }
          ),
          e === "large" && /* @__PURE__ */ r(s, { align: "center", spacing: a("6px"), pos: "relative", children: [
            /* @__PURE__ */ t(o, { text: "Læs mere", variant: "link" }),
            /* @__PURE__ */ t(d, { name: "ChevronRight", color: "dark" })
          ] })
        ]
      }
    ) }),
    e !== "large" && /* @__PURE__ */ t(
      i,
      {
        item: !0,
        alignItems: "center",
        justifyItems: "center",
        className: h.chevron,
        mod: { size: e },
        spacing: 0,
        visibleFrom: "sm",
        children: /* @__PURE__ */ t(d, { name: "ChevronRight", size: a("24px"), ml: a("6px") })
      }
    )
  ] });
};
p.displayName = "ListItemWithoutImage";
const j = p;
export {
  p as _ListItemWithoutImage,
  j as default
};
